import React from 'react';
import { cn } from 'src/@/lib/utils';
import { Label } from 'src/@/components/ui/label';
import { ZuiTooltip } from 'src/@/components/use/tooltip';
import Iconify from '../Iconify';

/**
 * RowInput component refactored from MUI to Shadcn/Tailwind.
 * 
 * @param {Object} props
 * @param {string} props.label - Label text
 * @param {"column" | "row"} [props.direction="column"] - Flex direction
 * @param {number} [props.spacing=1] - Spacing between label and input (MUI scale: 1 = 8px)
 * @param {React.ReactNode} props.input - Input element
 * @param {boolean} [props.isRequired] - Whether the field is mandatory
 * @param {string} [props.info] - Tooltip information text
 * @param {Object} [props.sx] - Ad-hoc styles (for MUI compatibility)
 * @param {string} [props.className] - Extra Tailwind classes
 */
export const RowInput = ({
  label,
  direction = "column",
  spacing = 1,
  input,
  isRequired,
  info,
  sx,
  className,
  ...props
}) => {
  const isColumn = direction === "column";

  return (
    <div
      className={cn(
        "flex w-full",
        isColumn ? "flex-col" : "flex-row items-center",
        className
      )}
      style={{
        gap: `${spacing * 8}px`,
        ...sx
      }}
      {...props}
    >
      <div className="flex flex-row items-center gap-0.5 shrink-0">
        <Label className="font-bold text-slate-700">
          {label}
        </Label>
        {isRequired && (
          <span className="text-[7px] text-[#f03] font-medium leading-none uppercase whitespace-nowrap">
            (Obrigatório)
          </span>
        )}
        {info && (
          <ZuiTooltip content={info}>
            <div className="flex items-center">
              <Iconify className="text-violet-600 w-4 h-4 cursor-help" icon="material-symbols:help" />
            </div>
          </ZuiTooltip>
        )}
      </div>
      {input}
    </div>
  );
};
